export interface TermsSection {
  title: string;
  description?: string;
  content?: Array<string | string[]>;
}

export interface TermsVersion {
  /** 시행일 (YYYY-MM-DD) */
  effectiveDate: string;
  /** 공고일 (YYYY-MM-DD) */
  announcedDate?: string;
  /** 개정 요지 */
  changeSummary?: string;
  sections: TermsSection[];
}

const COMMON_SECTIONS = {
  agreement: {
    title: "약관 동의",
    content: [
      "사용자는 본 약관에 따라 서비스를 이용해야 합니다.",
      "미성년자의 경우 법정대리인의 동의를 얻은 후 유료 서비스를 이용해야 합니다.",
      "사용자는 서비스를 이용함으로써 본 약관에 동의한 것으로 간주합니다.",
    ],
  },
  serviceProvision: {
    title: "서비스 제공",
    content: [
      "서비스 제공자는 서비스에 필요하다고 판단하는 조건을 만족시키는 사용자에 한하여 서비스를 제공할 수 있습니다.",
      "서비스 제공자는 정책 및 운영, 기술상의 필요에 따라 서비스를 변경하거나 중단할 수 있으며, 이에 대한 특별한 법률상의 규정이 없는 한 사용자에게 별도의 보상을 하지 않습니다.",
      "서비스 제공자는 사용자가 본 약관을 위반하거나 서비스의 운영을 방해한 경우 서비스 이용을 제한할 수 있습니다.",
    ],
  },
  ads: {
    title: "광고와 정보 제공",
    description: "서비스 제공자는 서비스 운영을 위해 서비스 또는 제3자의 광고를 게재할 수 있습니다.",
    content: [
      "서비스 제공자는 사용자에게 필요하다고 판단되는 정보를 서비스 내 알림으로 제공할 수 있으며 사용자는 언제든지 수신을 거절할 수 있습니다.",
    ],
  },
  userResponsibility: {
    title: "사용자의 책임",
    content: [
      "본 앱을 구동하기 위한 기기 및 네트워크 환경의 준비는 사용자의 비용과 책임으로 이루어져야 합니다.",
      "사용자는 서비스 이용 시 법령에 위반되거나 공공질서를 저해할 우려가 있는 행위를 해서는 안 됩니다.",
      [
        "신청 또는 변경 시 허위 내용의 등록",
        "타인의 정보 도용",
        "서비스에 게시된 정보의 변경",
        "서비스가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시",
        "서비스 및 기타 제3자의 저작권 등 지적재산권에 대한 침해",
        "서비스 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위",
        "외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 공개 또는 게시하는 행위",
        "서비스가 제공하는 서비스 이용 방법을 따르지 않고 비정상적인 방법으로 서비스를 이용하거나 시스템에 접근하는 행위",
      ],
      "사용자는 서비스 제공자의 서면 허가 없이 영리 목적으로 서비스를 사용할 수 없습니다. 또한, 서비스 파생물을 제작하거나 역파일, 소스 코드를 추출하는 행위도 금지됩니다.",
      "사용자는 자신의 책임하에 서비스를 이용해야 하며 본 서비스의 이용 결과에 대해 일체의 책임을 져야 합니다.",
      "사용자가 약관을 준수하지 않아 서비스 제공자에게 손해를 입힐 경우, 사용자는 서비스 제공자의 요구에 따라 이를 보상할 책임이 있습니다.",
    ],
  },
  accountDeletion: {
    title: "계정 탈퇴 및 데이터 삭제",
    content: [
      "사용자는 언제든지 서비스 내 설정(설정 → 프로필 → 계정 탈퇴) 또는 이메일을 통해 계정 탈퇴를 요청할 수 있습니다.",
      "계정 탈퇴 시 사용자의 계정 정보, 학습 데이터, 즐겨찾기, 구독 정보 등 모든 관련 데이터가 즉시 삭제됩니다.",
      "삭제된 데이터는 복구할 수 없으므로, 탈퇴 전 필요한 데이터를 백업하시기 바랍니다.",
      "유료 구독 중인 경우, 계정 탈퇴 전 Apple App Store 또는 Google Play에서 구독을 해지해 주시기 바랍니다. 계정 탈퇴만으로는 스토어 구독이 자동 해지되지 않습니다.",
    ],
  },
  disclaimer: {
    title: "서비스 제공자의 면책 사항",
    content: [
      "서비스 제공자는 본 서비스에서 제공하는 정보의 정확성, 신뢰성, 완전성에 대해 보증하지 않습니다.",
      "서비스 제공자는 사용자 상호간 또는 이용자와 제3자 간 콘텐츠를 매개로 하여 발생한 분쟁 등에 대하여 책임을 지지 않습니다.",
      "서비스 제공자는 천재지변, 불가항력 등으로 인해 서비스 제공이 불가능한 경우 책임을 지지 않습니다.",
      "서비스 제공자는 사용자가 서비스 이용에 불편함이 없도록 최선을 다해 노력합니다. 다만, 임시 점검이나 유지·보수 등으로 서비스 제공이 원활하지 않을 수 있습니다.",
      "서비스 제공자는 사용자의 귀책사유로 인한 서비스 이용 장애에 대해 책임을 지지 않습니다.",
      "서비스 제공자는 서비스에 대한 결함, 오류, 버그를 최소화하기 위해 지속해서 서비스를 개선하지만, 법률상으로 이러한 하자 없이 서비스를 제공할 의무를 갖지 않습니다.",
    ],
  },
  privacy: {
    title: "개인정보 보호",
    description:
      "서비스 제공자는 사용자에게 수집한 개인정보를 사용자가 동의한 범위 내에서만 사용합니다. 사용자의 개인정보 처리에 관련한 상세한 내용은 개인정보 처리방침에서 확인할 수 있습니다.",
  },
  disputeResolution: {
    title: "분쟁 해결",
    content: [
      "본 약관과 관련하여 분쟁이 발생할 경우, 서비스 제공자의 본사 소재지를 관할하는 법원을 제1심 법원으로 합니다.",
      "서비스는 사용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기 위하여 피해보상처리기구를 설치·운영합니다.",
      "서비스는 사용자로부터 제출되는 불만사항 및 의견을 우선적으로 처리합니다. 다만, 신속한 처리가 곤란한 경우에는 이용자에게 그 사유와 처리 일정을 즉시 통보합니다.",
    ],
  },
  jurisdiction: {
    title: "재판권 및 준거법",
    content: [
      "서비스와 사용자 간에 발생한 전자상거래 분쟁에 관한 소송은 재소 당시의 서비스 제공자의 주소에 의하고, 부득이한 경우에는 거소를 관할하는 지방법원의 전속관할로 합니다.",
      "서비스와 사용자 간에 제기된 소송에는 한국법을 적용합니다.",
    ],
  },
  amendment: {
    title: "약관의 효력 및 변경",
    content: [
      "서비스 제공자는 법률 변경이나 서비스 변경사항을 반영하기 위한 목적 등으로 본 약관을 수정할 수 있습니다.",
      "서비스 제공자는 필요한 경우 본 약관을 변경할 수 있으며, 변경된 약관은 서비스에 게시함으로써 효력이 발생합니다.",
    ],
  },
} satisfies Record<string, TermsSection>;

/** 최신순 정렬. [0]이 현재 시행 중인 약관 */
export const TERMS_VERSIONS: TermsVersion[] = [
  {
    effectiveDate: "2026-07-17",
    announcedDate: "2026-07-09",
    changeSummary: "청약철회(구매 취소 및 환불) 조항 신설, 부가가치세 포함 가격 표기 명시",
    sections: [
      COMMON_SECTIONS.agreement,
      COMMON_SECTIONS.serviceProvision,
      {
        title: "유료 서비스 (Plus 구독)",
        description: "서비스는 무료 기본 기능과 유료 구독(Plus)을 포함합니다. 유료 구독에 관한 사항은 다음과 같습니다.",
        content: [
          "유료 구독은 Apple App Store 또는 Google Play를 통해 결제되며, 각 스토어의 결제 정책을 따릅니다.",
          "서비스 내에 표시되는 모든 가격은 부가가치세(VAT)가 포함된 금액입니다.",
          "구독은 사용자가 갱신일 최소 24시간 전에 해지하지 않는 한 자동으로 갱신됩니다.",
          "구독 해지는 Apple App Store 또는 Google Play의 구독 관리 메뉴에서 직접 처리해야 합니다.",
          "환불은 각 앱 스토어의 환불 정책에 따르며, 서비스 제공자가 직접 환불을 처리하지 않습니다.",
          "무료 체험 기간이 제공되는 경우, 체험 기간 종료 시 자동으로 유료 구독으로 전환됩니다.",
        ],
      },
      {
        title: "청약철회 (구매 취소 및 환불)",
        description:
          "사용자는 「전자상거래 등에서의 소비자보호에 관한 법률」에 따라 구매일로부터 7일 이내에 청약철회를 요청할 수 있습니다.",
        content: [
          "청약철회는 구매일(구독 개시일)로부터 7일 이내에 요청할 수 있습니다. 다만, 콘텐츠 이용이 개시되었거나 관련 법령에서 정한 청약철회 제한 사유에 해당하는 경우 청약철회가 제한될 수 있습니다.",
          "Apple App Store에서 결제한 경우: 기기의 설정 > Apple 계정 > 구독에서 해지하거나, reportaproblem.apple.com에 접속하여 해당 구매 건에 대한 환불을 신청할 수 있습니다.",
          "Google Play에서 결제한 경우: Google Play 스토어 > 결제 및 정기 결제 > 예산 및 기록에서 해당 구매 건의 환불을 신청할 수 있습니다.",
          "청약철회 및 환불에 어려움이 있는 경우 하단 문의처(이메일)로 연락 주시면 처리 방법을 안내해 드립니다.",
        ],
      },
      COMMON_SECTIONS.ads,
      COMMON_SECTIONS.userResponsibility,
      COMMON_SECTIONS.accountDeletion,
      COMMON_SECTIONS.disclaimer,
      COMMON_SECTIONS.privacy,
      COMMON_SECTIONS.disputeResolution,
      COMMON_SECTIONS.jurisdiction,
      COMMON_SECTIONS.amendment,
    ],
  },
  {
    effectiveDate: "2026-04-03",
    sections: [
      COMMON_SECTIONS.agreement,
      COMMON_SECTIONS.serviceProvision,
      {
        title: "유료 서비스 (Plus 구독)",
        description: "서비스는 무료 기본 기능과 유료 구독(Plus)을 포함합니다. 유료 구독에 관한 사항은 다음과 같습니다.",
        content: [
          "유료 구독은 Apple App Store 또는 Google Play를 통해 결제되며, 각 스토어의 결제 정책을 따릅니다.",
          "구독은 사용자가 갱신일 최소 24시간 전에 해지하지 않는 한 자동으로 갱신됩니다.",
          "구독 해지는 Apple App Store 또는 Google Play의 구독 관리 메뉴에서 직접 처리해야 합니다.",
          "환불은 각 앱 스토어의 환불 정책에 따르며, 서비스 제공자가 직접 환불을 처리하지 않습니다.",
          "무료 체험 기간이 제공되는 경우, 체험 기간 종료 시 자동으로 유료 구독으로 전환됩니다.",
        ],
      },
      COMMON_SECTIONS.ads,
      COMMON_SECTIONS.userResponsibility,
      COMMON_SECTIONS.accountDeletion,
      COMMON_SECTIONS.disclaimer,
      COMMON_SECTIONS.privacy,
      COMMON_SECTIONS.disputeResolution,
      COMMON_SECTIONS.jurisdiction,
      COMMON_SECTIONS.amendment,
    ],
  },
];

export function formatTermsDate(date: string): string {
  const [year, month, day] = date.split("-");

  return `${year}년 ${month}월 ${day}일`;
}
